import React from "react";
import { PUMPFUN_URL } from "../../lib/memeData";

const STEPS = [
  {
    n: 1,
    color: "#F4A261",
    title: "summon phantom",
    body: "download the phantom wallet. it lives in your phone or browser. free. spooky. magical.",
    cta: { label: "get phantom 👻", href: "https://phantom.app/" },
    rotate: -2,
  },
  {
    n: 2,
    color: "#2A9D8F",
    title: "fund with $SOL",
    body: "buy some solana inside phantom or send it from a faraway exchange. you need fuel, retard.",
    cta: { label: "what's solana", href: "https://solana.com/" },
    rotate: 1.5,
  },
  {
    n: 3,
    color: "#E8742C",
    title: "swap for $RETARD",
    body: "paste the CA into pump.fun, smash the buy button, never look at the chart again.",
    cta: { label: "buy on pump.fun 🚀", href: PUMPFUN_URL },
    rotate: -1,
  },
];

export const HowToBuy = () => {
  return (
    <section id="how-to-buy" className="px-5 md:px-10 py-14" data-testid="how-to-buy-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-display text-5xl md:text-7xl">
            how 2 <span className="text-[#E8742C]">buy</span>
          </h2>
          <p className="text-lg md:text-xl text-[#1A1A1A]/70 mt-2">
            three baby steps. you got this. probably.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map((s) => (
            <div
              key={s.n}
              className="crayon-card relative px-6 py-7"
              style={{ transform: `rotate(${s.rotate}deg)` }}
              data-testid={`how-to-buy-step-${s.n}`}
            >
              <div
                className="absolute -top-7 -left-4 w-16 h-16 rounded-full border-4 border-[#1A1A1A] flex items-center justify-center font-display text-4xl text-white shadow-[4px_4px_0_#1A1A1A]"
                style={{ background: s.color }}
              >
                {s.n}
              </div>
              <h3 className="font-display text-3xl md:text-4xl mt-4">{s.title}</h3>
              <p className="text-lg mt-2 text-[#1A1A1A]/80">{s.body}</p>
              <a
                href={s.cta.href}
                target="_blank"
                rel="noreferrer"
                className="crayon-btn crayon-btn--ghost mt-5 text-xl"
                data-testid={`how-to-buy-cta-${s.n}`}
              >
                {s.cta.label}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToBuy;
